'use client';

import React, { useCallback, useEffect } from 'react';
import Image from '@/components/ui/Motion/image';
import { cls } from '@/lib/utils';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogOverlay,
  DialogHeader,
} from '../dialog';
import Flex from '../layout/flex';

interface GalleryLightboxProperties {
  src: string;
  alt: string;
  isOpen: boolean;
  onClose: () => void;
}

function GalleryLightbox({
  src,
  alt,
  isOpen,
  onClose,
}: GalleryLightboxProperties) {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogOverlay className="backdrop-blur-md bg-black/40" />

      <DialogContent className="flex flex-col max-w-[90vw] min-w-[90vw] max-h-[90vh] min-h-[90vh]">
        <DialogHeader className="h-min">
          <DialogTitle>A closer look!</DialogTitle>
        </DialogHeader>

        {/* Image Container */}
        <Flex
          direction="column"
          justify="center"
          items="center"
          className="flex-1"
        >
          <Image
            src={src}
            alt={alt}
            fill
            sizes="90vw"
            showSkeleton={true}
            wrapperClassName={cls`w-full h-auto rounded-lg flex-1`}
          />
        </Flex>
      </DialogContent>
    </Dialog>
  );
}

export default GalleryLightbox;
